<div class="h-100 overflow-auto">
    <div class="container-sm-fluid pt-3 px-sm-4">
        <dx-tabs
            keyExpr="type"
            [items]="tabs"
            [selectedItemKeys]="[selectedTab]"
            [showNavButtons]="false"
            stylingMode="primary"
            class="mb-2"
            (onItemClick)="onTabClick($event.itemData.type)"
        ></dx-tabs>
    </div>

    @switch (selectedTab) {
        @case (TabType.Vendors) {
            <app-my-score-vendors></app-my-score-vendors>
        }
        @case (TabType.Operations) {
            <app-my-score-operations></app-my-score-operations>
        }
        @case (TabType.Finance) {
            <app-my-score-finance></app-my-score-finance>
        }
    }
</div>
